import { render, staticRenderFns } from "./BulkResultUpload.vue?vue&type=template&id=2390076c&"
import script from "./BulkResultUpload.vue?vue&type=script&lang=js&"
export * from "./BulkResultUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports